window.ZUG_PRODUCT_RECIPES = {
  /*
   * Roll Labels and Label Sheets stay independent. Roll Labels use the shared
   * Products 2.0 controls and become commercially active only after their
   * production pricing asset passes validation. Label Sheets remain pending.
   */
  roll_labels: {
    productType: "label_family",
    familyLabel: "Roll Labels",
    unitLabel: "label",
    activationTag: "ZUG_MAT:roll_labels",
    configurationStatus: "configured",
    quantity: {
      status: "configured",
      min: 100,
      max: 50000,
      presets: [100, 250, 500, 1000],
      validationMode: "products_2_0_interpolation",
      validationMessage: "Enter a quantity from 100 to 50,000."
    },
    size: {
      status: "configured",
      workflow: "products_2_0_shared",
      min: { w: 0.5, h: 0.5 },
      max: { w: 12, h: 12 },
      precision: 3,
      increment: null,
      maximumAreaIn2: 144,
      units: ["in", "mm"],
      defaultUnit: "in",
      presets: [
        { key: "2x2", label: "2\" x 2\"", w: 2, h: 2 },
        { key: "3x3", label: "3\" x 3\"", w: 3, h: 3 },
        { key: "4x4", label: "4\" x 4\"", w: 4, h: 4 },
        { key: "5x5", label: "5\" x 5\"", w: 5, h: 5 },
        { key: "6x6", label: "6\" x 6\"", w: 6, h: 6 }
      ]
    },
    availableShapes: [
      { key: "custom", label: "Custom Shape", productTag: "ZUG_LABEL_SHAPE:custom" },
      { key: "round", label: "Circle", productTag: "ZUG_LABEL_SHAPE:round" },
      { key: "square", label: "Square", productTag: "ZUG_LABEL_SHAPE:square" },
      { key: "rectangle", label: "Rectangle", productTag: "ZUG_LABEL_SHAPE:rectangle" },
      { key: "oval", label: "Oval", productTag: "ZUG_LABEL_SHAPE:oval" }
    ],
    availableMaterials: [
      {
        key: "white_bopp",
        label: "White BOPP",
        productTag: "ZUG_LABEL_MATERIAL:white_bopp",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/gloss-laminated-stickers.gif?v=1629796775"
      },
      {
        key: "clear",
        label: "Clear BOPP",
        productTag: "ZUG_LABEL_MATERIAL:clear",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/clear.gif?v=1629799292"
      },
      {
        key: "metallic",
        label: "Metallic",
        productTag: "ZUG_LABEL_MATERIAL:metallic",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/silver.gif?v=1629800375"
      },
      {
        key: "holographic_metallic",
        label: "Holographic",
        productTag: "ZUG_LABEL_MATERIAL:holographic_metallic",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/holographic.gif?v=1629799291"
      },
      {
        key: "semi_gloss_paper",
        label: "Semi-Gloss Paper",
        productTag: "ZUG_LABEL_MATERIAL:semi_gloss_paper",
        finishGroup: "paper",
        waterproof: false,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/matte-stickers.gif?v=1629799291"
      },
      {
        key: "kraft_paper",
        label: "Kraft Paper",
        productTag: "ZUG_LABEL_MATERIAL:kraft_paper",
        finishGroup: "paper",
        waterproof: false,
        iconAsset: "kraft-paper.webp"
      }
    ],
    pricing: {
      status: "approved",
      mode: "market_calibrated_parametric_v1",
      schemaVersion: 2,
      asset: "zug-roll-labels-pricing.json"
    },
    turnaround: {
      status: "configured",
      workflow: "products_2_0_shared",
      source: "product_metafields_with_shared_fallback"
    },
    artwork: {
      workflow: "products_2_0_shared",
      mode: "standard"
    },
    preview: {
      workflow: "products_2_0_shared",
      enabled: true
    },
    options: {
      easyPeel: false,
      finishes: [
        {
          key: "gloss",
          label: "Gloss Laminated",
          enabled: true,
          groups: ["film"],
          iconAsset: "glossy-laminated-stickers-labels.webp"
        },
        {
          key: "matte",
          label: "Matte Laminated",
          enabled: true,
          groups: ["film"],
          iconAsset: "matte-laminated-stickers-labels.webp"
        },
        {
          key: "no_lamination",
          label: "No Lamination",
          enabled: true,
          groups: ["paper"],
          iconAsset: "non-laminated-semi-gloss-sticker-labels.webp"
        },
        {
          key: "gloss_laminate",
          label: "Gloss Laminate",
          enabled: true,
          groups: ["paper"],
          iconAsset: "glossy-laminated-stickers-labels.webp"
        },
        {
          key: "matte_laminate",
          label: "Matte Laminate",
          enabled: true,
          groups: ["paper"],
          iconAsset: "matte-laminated-stickers-labels.webp"
        }
      ],
      applicationMethods: [
        { key: "hand", label: "Hand Applied", buttonLabel: "Hand Applied", orderAdjustmentCents: 0 },
        {
          key: "machine",
          label: "Machine Applied",
          buttonLabel: "Machine Applied",
          orderAdjustmentCents: 2500,
          adjustmentQuantityBelow: 5000,
          tooltipTitle: "Machine Applied",
          tooltip: "Adds a $25 setup fee for orders under 5,000 labels. This fee is automatically waived for quantities of 5,000 or more."
        }
      ],
      unwindDirections: [
        {
          key: "bottom",
          label: "#1 Bottom side first",
          image: "https://cdn.shopify.com/s/files/1/2692/4122/files/roll-bottom.png?v=1598612019"
        },
        {
          key: "right",
          label: "#2 Right side first",
          image: "https://cdn.shopify.com/s/files/1/2692/4122/files/roll-right.png?v=1598612020"
        },
        {
          key: "top",
          label: "#3 Top side first",
          image: "https://cdn.shopify.com/s/files/1/2692/4122/files/roll-top.png?v=1598612020"
        },
        {
          key: "left",
          label: "#4 Left side first",
          image: "https://cdn.shopify.com/s/files/1/2692/4122/files/roll-left.png?v=1598612019"
        }
      ]
    }
  },
  label_sheets: {
    productType: "label_family",
    familyLabel: "Label Sheets",
    unitLabel: "label",
    activationTag: "ZUG_MAT:label_sheets",
    configurationStatus: "configured",
    quantity: {
      status: "configured",
      min: 25,
      max: 5000,
      presets: [25, 50, 100, 250, 500],
      validationMode: "label_sheets_v1",
      validationMessage: "Enter 25 or a multiple of 10 from 30 to 5,000."
    },
    size: {
      status: "configured",
      workflow: "products_2_0_shared",
      min: { w: 0.5, h: 0.5 },
      max: { w: 12, h: 12 },
      precision: 3,
      increment: null,
      maximumAreaIn2: 144,
      units: ["in", "mm"],
      defaultUnit: "in",
      presets: [
        { key: "2x2", label: "2\" x 2\"", w: 2, h: 2 },
        { key: "3x3", label: "3\" x 3\"", w: 3, h: 3 },
        { key: "4x4", label: "4\" x 4\"", w: 4, h: 4 },
        { key: "5x5", label: "5\" x 5\"", w: 5, h: 5 },
        { key: "6x6", label: "6\" x 6\"", w: 6, h: 6 }
      ]
    },
    availableShapes: [
      { key: "custom", label: "Custom Shape", productTag: "ZUG_LABEL_SHAPE:custom" },
      { key: "round", label: "Circle", productTag: "ZUG_LABEL_SHAPE:round" },
      { key: "square", label: "Square", productTag: "ZUG_LABEL_SHAPE:square" },
      { key: "rectangle", label: "Rectangle", productTag: "ZUG_LABEL_SHAPE:rectangle" },
      { key: "oval", label: "Oval", productTag: "ZUG_LABEL_SHAPE:oval" }
    ],
    availableMaterials: [
      {
        key: "white_bopp",
        label: "White BOPP",
        productTag: "ZUG_LABEL_MATERIAL:white_bopp",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/gloss-laminated-stickers.gif?v=1629796775"
      },
      {
        key: "clear",
        label: "Clear",
        productTag: "ZUG_LABEL_MATERIAL:clear",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/clear.gif?v=1629799292"
      },
      {
        key: "metallic",
        label: "Metallic",
        productTag: "ZUG_LABEL_MATERIAL:metallic",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/silver.gif?v=1629800375"
      },
      {
        key: "holographic_metallic",
        label: "Holographic Metallic",
        productTag: "ZUG_LABEL_MATERIAL:holographic_metallic",
        finishGroup: "film",
        waterproof: true,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/holographic.gif?v=1629799291"
      },
      {
        key: "semi_gloss_paper",
        label: "Semi-Gloss Paper",
        productTag: "ZUG_LABEL_MATERIAL:semi_gloss_paper",
        finishGroup: "paper",
        waterproof: false,
        icon: "https://cdn.shopify.com/s/files/1/2692/4122/files/matte-stickers.gif?v=1629799291"
      }
    ],
    pricing: {
      status: "approved_launch_v1",
      mode: "roll_labels_commercial_curve_v1",
      asset: "zug-label-sheets-pricing.json",
      foundationAsset: "zug-roll-labels-pricing.json"
    },
    turnaround: {
      status: "configured",
      workflow: "products_2_0_shared",
      source: "product_metafields_with_shared_fallback"
    },
    artwork: {
      workflow: "products_2_0_shared",
      mode: "standard"
    },
    preview: {
      workflow: "products_2_0_shared",
      enabled: true
    },
    options: {
      easyPeel: false,
      finishes: [
        {
          key: "gloss",
          label: "Gloss Laminate",
          enabled: true,
          groups: ["film"],
          iconAsset: "glossy-laminated-stickers-labels.webp"
        },
        {
          key: "matte",
          label: "Matte Laminate",
          enabled: true,
          groups: ["film"],
          iconAsset: "matte-laminated-stickers-labels.webp"
        },
        {
          key: "no_lamination",
          label: "No Lamination",
          enabled: true,
          groups: ["paper"],
          iconAsset: "non-laminated-semi-gloss-sticker-labels.webp"
        },
        {
          key: "gloss_laminate",
          label: "Gloss Laminate",
          enabled: true,
          groups: ["paper"],
          iconAsset: "glossy-laminated-stickers-labels.webp"
        },
        {
          key: "matte_laminate",
          label: "Matte Laminate",
          enabled: true,
          groups: ["paper"],
          iconAsset: "matte-laminated-stickers-labels.webp"
        }
      ]
    }
  },
  sticker_sheets: {
    productType: "sticker_sheets",
    unitLabel: "sheet",
    pricingMultiplier: 1.15,
    sizePresets: [
      { key: "4x6", w: 4, h: 6, label: '4" \u00d7 6"' },
      { key: "5x7", w: 5, h: 7, label: '5" \u00d7 7"' },
      { key: "8.5x11", w: 8.5, h: 11, label: '8.5" \u00d7 11"' },
      { key: "custom", custom: true, label: "Custom" }
    ],
    customSize: {
      min: { w: 4, h: 4 },
      max: { w: 24, h: 36 }
    },
    materials: [
      { key: "gloss_laminated", label: "Gloss Laminated", materialKey: "non_lam", multiplier: 1.25, icon: "gloss" },
      { key: "matte_laminated", label: "Matte Laminated", materialKey: "non_lam", multiplier: 1.25, icon: "matte" },
      { key: "holographic", label: "Holographic", materialKey: "holographic", multiplier: 2.0, icon: "holographic" },
      { key: "chrome", label: "Chrome", materialKey: "chrome", multiplier: 2.0, icon: "chrome" },
      { key: "clear", label: "Clear", materialKey: "clear", multiplier: 1.625, icon: "clear" }
    ],
    options: {
      easyPeel: false
    },
    preview: {
      enabled: false,
      instantProof: false
    },
    upload: {
      mode: "basic_multiple",
      multiple: true
    }
  },
  clear: {
    materialKey: "clear",
    isClearMaterial: true,
    whiteBaseToggle: true,
    defaultWhiteBase: true,
    unitLabel: "sticker"
  },
  temp_tattoos: {
    multiplier: 1.50,
    unitLabel: "tattoo",
    pricePerLabel: "tattoo",
    maxSize: { w: 10, h: 12 },
    sizePresets: [
      { key: "1x1", w: 1, h: 1, label: '1" \u00d7 1"' },
      { key: "2x2", w: 2, h: 2, label: '2" \u00d7 2"' },
      { key: "3x3", w: 3, h: 3, label: '3" \u00d7 3"' },
      { key: "4x4", w: 4, h: 4, label: '4" \u00d7 4"' },
      { key: "custom", custom: true, label: "Custom" }
    ],
    options: {
      easyPeel: false
    },
    pricing: {
      mode: "AREA_TABLE",
      pricing_table_asset: "temp_tattoo_base_unit_price_table_v1.json",
      tier_axis: "area_in2"
    }
  },
  white_static_cling: {
    materialKey: "white_static_cling",
    multiplier: 1.50,
    unitLabel: "cling",
    usePricingTable: "stickers_v2",
    disableEasyPeel: true,
    sizeOptions: "default_sticker_sizes",
    qtyOptions: "default_sticker_qty",
    previewMode: "standard_sticker"
  },
  clear_static_cling: {
    materialKey: "clear_static_cling",
    multiplier: 1.50,
    unitLabel: "cling",
    usePricingTable: "stickers_v2",
    disableEasyPeel: true,
    sizeOptions: "default_sticker_sizes",
    qtyOptions: "default_sticker_qty",
    previewMode: "standard_sticker",
    applyLocationToggle: true,
    whiteInkToggle: true,
    reverseMaterialKey: "clear_static_cling_reverse"
  },
  clear_static_cling_reverse: {
    materialKey: "clear_static_cling_reverse",
    multiplier: 1.50,
    unitLabel: "cling",
    usePricingTable: "stickers_v2",
    disableEasyPeel: true,
    sizeOptions: "default_sticker_sizes",
    qtyOptions: "default_sticker_qty",
    previewMode: "standard_sticker",
    applyLocationToggle: true,
    whiteInkToggle: true,
    printOrientation: "mirrored",
    normalMaterialKey: "clear_static_cling"
  },
  coaster: {
    materialKey: "coaster",
    unitLabel: "coaster",
    isCoaster: true,
    minQty: 5,
    disableEasyPeel: true,
    disableLamination: true,
    pricing: {
      mode: "COASTER_TIERS"
    }
  },
  button: {
    productType: "fixed_shape",
    previewMode: "fixed_shape",
    unitLabel: "button",
    materialKey: "button",
    shape: "round",
    sizes: [
      { key: "1_round", w: 1, h: 1, label: '1"', productTag: "zug_mat:button_1" },
      { key: "1.25_round", w: 1.25, h: 1.25, label: '1.25"', productTag: "zug_mat:button_1.25", priceMultiplier: 1.06 }
    ],
    quantity: {
      min: 5,
      max: 10000,
      presets: [5, 50, 100, 250, 500],
      isValid: function(qty) {
        return qty === 5 || (qty >= 10 && qty % 10 === 0);
      },
      validationMessage: "Enter 5, or a multiple of 10 starting at 10."
    },
    options: {
      easyPeel: false,
      shapeControls: false,
      cutStyle: false,
      backgroundRemoval: false,
      customSize: false
    },
    preview: {
      reviewOnly: true,
      safeZone: true,
      safeIn: 0.125,
      bleedIn: 0,
      dpi: true,
      editing: true
    },
    pricing: {
      mode: "LINEAR_UNIT_ANCHORS",
      /*
       * Current authoritative 1-inch Button totals, expressed as unit-price
       * anchors so the shared Products 2.0 linear interpolation path can be
       * reused. Size-level multipliers are configured on the size entries.
       */
      anchors: {
        "5": 1.398,
        "25": 0.3596,
        "50": 0.2798,
        "75": 0.2532,
        "100": 0.3499,
        "150": 0.3066,
        "200": 0.26495,
        "250": 0.25196,
        "500": 0.25198,
        "750": 0.20132,
        "1000": 0.19999,
        "2500": 0.195196,
        "5000": 0.189998,
        "10000": 0.184999
      }
    },
    cart: {
      baseMode: "product_single"
    }
  }
};

window.ZUG_PRODUCT_RECIPE_UTILS = window.ZUG_PRODUCT_RECIPE_UTILS || {};
window.ZUG_PRODUCT_RECIPE_UTILS.getApplicationOrderAdjustmentCents = function(recipe, methodKey, quantity) {
  var methods = recipe && recipe.options && recipe.options.applicationMethods;
  if (!Array.isArray(methods)) return 0;
  var method = methods.filter(function(candidate) {
    return candidate.key === methodKey;
  })[0];
  if (!method) return 0;
  var adjustmentCents = Number(method.orderAdjustmentCents) || 0;
  var quantityBelow = Number(method.adjustmentQuantityBelow);
  if (!(adjustmentCents > 0)) return 0;
  if (quantityBelow > 0 && Number(quantity) >= quantityBelow) return 0;
  return adjustmentCents;
};

window.ZUG_PRODUCT_RECIPE_UTILS.getMaterialFinishes = function(recipe, materialKey) {
  var materials = recipe && recipe.availableMaterials;
  var finishes = recipe && recipe.options && recipe.options.finishes;
  if (!Array.isArray(materials) || !Array.isArray(finishes)) return [];
  var material = materials.filter(function(candidate) {
    return candidate.key === materialKey;
  })[0];
  if (!material) return [];
  return finishes.filter(function(finish) {
    return finish.enabled && Array.isArray(finish.groups) && finish.groups.indexOf(material.finishGroup) !== -1;
  });
};
